import { render, staticRenderFns } from "./Trissen.vue?vue&type=template&id=e02827e8"
import script from "./Trissen.vue?vue&type=script&lang=js"
export * from "./Trissen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports